import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { Owner, Company, UserType, User, Project, ProjectService } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subscription, combineLatest } from 'rxjs';
import { ProjectEditComponent } from '../project-edit/project-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-project-list',
	templateUrl: './project-list.component.html',
	styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit, AfterViewInit, OnDestroy {


	@Input()
	companyid: number;


	loading: boolean = false;
	rows: Project[];

	advancedSearch: Search = new Search('project join company join tender on project.companyid = company.id and project.tenderid = tender.id', `concat(project.name,'',project.description)`, 'project');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;



	loggedUser: User;
	subcription: Subscription;

	constructor(
		private projectService: CrudService<Project>,
		private projectsService: ProjectService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	ngAfterViewInit() {

		let urlparamsreq;
		const requests: Observable<any>[] = [];
		if (this.listfilters) {
			urlparamsreq = this.listfilters.readParams();
			requests.push(urlparamsreq);
		}


		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
				if (this.loggedUser.utype === UserType.company) {
					this.companyid = this.loggedUser.companyid;
				}
				this.search(data[0]);
			} else {
				this.loggedUser = data[0];
				if (this.loggedUser.utype === UserType.company) {
					this.companyid = this.loggedUser.companyid;
				}


				this.search();
			}



		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();
		let datarequest, countrequest;


		if (this.companyid) {
			// this.advancedSearch.addSimpleFilter('companyid', this.companyid);

			datarequest = this.projectsService.getOngoingProjects(this.companyid, this.advancedSearch.page);
			countrequest = this.projectsService.getOngoingProjectsCount(this.companyid);


		} else {
			datarequest = this.projectService.searchEntities(Project, 'project', this.advancedSearch, this.advancedSearch.page);
			countrequest = this.projectService.countEntities(Project, 'project', this.advancedSearch);
		}



		forkJoin([datarequest, countrequest]).subscribe((results: any) => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {

		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any) {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.router.navigate([`/company/project/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			}
		}
	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: Project, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-project-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.projectService.deleteEntity(Project, 'project', row).subscribe(() => {
					this.translateService.get(['labels.project-deleted', 'labels.project']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.project-deleted'], messages['labels.project']);
						this.load();
					});
				});
			}
		});
	}


	edit(ownerid?: number) {
		const modal = this.modalService.open(ProjectEditComponent,
			{
				centered: true,
				size: 'lg',
				backdrop: 'static',
				keyboard: false
			});

		modal.componentInstance.companyid = this.companyid;

		if (ownerid) {
			modal.componentInstance.load(ownerid);
		}
		modal.result.then((newItem: Owner) => {
			this.load();
		}).catch(() => { });
	}

}
